import * as mutation_types from '../mutation-types'
import * as action_types from '../action-types'
import filtersFromQuestions from "@/mixins/filters-from-questions"

const state = {
    canEdit: true,
    active: {},
    list: [],
    popup: null,
    count: {
        existing: null,
        expected: null,
        legacy: null,
    }
}

const mutations = {
    [mutation_types.FILTERS_SET] (state, data) {
        state.list = data;
    },
    [mutation_types.FILTERS_COUNT_LEGACY_SET] (state, count) {
        state.count.legacy = count;
    },
    [mutation_types.FILTERS_COUNT_EXISTING_SET] (state, count) {
        state.count.existing = count;
    },
    [mutation_types.FILTERS_COUNT_EXPECTED_SET] (state, count) {
        state.count.expected = count;
    },
    [mutation_types.FILTERS_ACTIVE_SET] (state, data) {
        state.active = data;
    },
    [mutation_types.FILTERS_POPUP_SET] (state, filter) {
        state.popup = filter;
    },
    [mutation_types.FILTERS_CAN_EDIT_SET] (state, canEdit) {
        state.canEdit = canEdit;
    },
}

const reformat = (oldFilters, data) => {
    let reformatted = []

    Object.keys(oldFilters).forEach(key => {
        const { id, visibility, question_id } = data.find(filter => filter.name === key)
        const obj = {
            id,
            name: key,
            type: key,
            mapping: oldFilters[key].reduce((arr, value) => {
                arr.push({ question_options: [{ value }] })
                return arr;
            }, []),
            visibility,
            question_id
        }
        reformatted.push(obj)
    })

    reformatted = addHiddenFiltersToEnableVisibility(oldFilters, data, reformatted)

    return reformatted
}

const addHiddenFiltersToEnableVisibility = (oldFilters, data, reformatted) => {
    data.filter(f => !Object.keys(oldFilters).includes(f.name))
        .forEach(f => reformatted.push(f))

    return reformatted
}

const actions = {
    async [action_types.FILTERS_LOAD] (state, { $http, surveyPeriodId }) {
        const [{ filter_properties: oldFilters }, { data, meta }] = await Promise.all([
            await filtersFromQuestions.methods.getFilters($http),
            await filtersFromQuestions.methods.getVisibility($http, surveyPeriodId),
        ])

        state.commit(mutation_types.FILTERS_COUNT_LEGACY_SET, Object.keys(oldFilters).length)
        state.commit(mutation_types.FILTERS_CAN_EDIT_SET, meta.can_edit_filters)

        const oldFiltersInNewFormat = reformat(oldFilters, data)
        state.commit(mutation_types.FILTERS_COUNT_EXISTING_SET, oldFiltersInNewFormat.length)
        state.commit(mutation_types.FILTERS_SET, oldFiltersInNewFormat)
    }
}

export default {
    state,
    mutations,
    actions
}